function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "blog_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "blog_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#blog_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "web-browser-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "web-browser-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#blog_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "2-PT",
  transform: "translate(0.54003906 0.54003906)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.810811 18.9189C0.59577 18.9189 0.389538 18.8335 0.237481 18.6814C0.0854245 18.5294 2.40048e-16 18.3231 0 18.1081L0 0.810811C1.20024e-16 0.59577 0.0854245 0.389538 0.237481 0.237481C0.389538 0.0854245 0.59577 2.40048e-16 0.810811 0L18.1081 0C18.3231 1.20024e-16 18.5294 0.0854245 18.6814 0.237481C18.8335 0.389538 18.9189 0.59577 18.9189 0.810811L18.9189 18.1081C18.9189 18.3231 18.8335 18.5294 18.6814 18.6814C18.5294 18.8335 18.3231 18.9189 18.1081 18.9189L0.810811 18.9189ZM0.619701 0.619701C0.569015 0.670386 0.540541 0.739131 0.540541 0.810811L0.540541 18.1081C0.540541 18.1798 0.569015 18.2485 0.619701 18.2992C0.670386 18.3499 0.739131 18.3784 0.810811 18.3784L18.1081 18.3784C18.1798 18.3784 18.2485 18.3499 18.2992 18.2992C18.3499 18.2485 18.3784 18.1798 18.3784 18.1081L18.3784 0.810811C18.3784 0.739131 18.3499 0.670386 18.2992 0.619701C18.2485 0.569015 18.1798 0.540541 18.1081 0.540541L0.810811 0.540541C0.739131 0.540541 0.670386 0.569015 0.619701 0.619701Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.3784 0L18.3784 0.540548L0 0.540548L0 0L18.3784 0Z",
  transform: "translate(0.2705078 4.3242188)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.480461 1.97997C0.30268 1.86118 0.164116 1.69234 0.0822923 1.49479C0.000468409 1.29725 -0.0209404 1.07988 0.020773 0.870173C0.0624865 0.660464 0.165449 0.467834 0.31664 0.316642C0.467831 0.16545 0.660459 0.0624869 0.870167 0.0207732C1.07987 -0.0209406 1.29724 0.000468412 1.49478 0.0822929C1.69232 0.164117 1.86116 0.302682 1.97995 0.480465C2.09874 0.658248 2.16215 0.867264 2.16215 1.08108C2.16215 1.3678 2.04825 1.64278 1.84551 1.84552C1.64277 2.04826 1.36779 2.16216 1.08107 2.16216C0.867258 2.16216 0.658243 2.09876 0.480461 1.97997ZM0.780768 0.631639C0.691877 0.691034 0.622595 0.775455 0.581683 0.874226C0.540771 0.972997 0.530067 1.08168 0.550924 1.18654C0.57178 1.29139 0.623261 1.38771 0.698856 1.4633C0.774452 1.5389 0.870766 1.59038 0.97562 1.61124C1.08047 1.63209 1.18916 1.62139 1.28793 1.58048C1.3867 1.53956 1.47112 1.47028 1.53051 1.38139C1.58991 1.2925 1.62161 1.18799 1.62161 1.08108C1.62161 0.937721 1.56466 0.800233 1.46329 0.698862C1.36192 0.597491 1.22443 0.540541 1.08107 0.540541C0.974166 0.540541 0.869659 0.572243 0.780768 0.631639Z",
  transform: "translate(15.40625 1.3515625)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.480461 1.97997C0.30268 1.86118 0.164116 1.69234 0.0822923 1.49479C0.000468409 1.29725 -0.0209404 1.07988 0.020773 0.870173C0.0624865 0.660464 0.165449 0.467834 0.31664 0.316642C0.467831 0.16545 0.660459 0.0624869 0.870167 0.0207732C1.07987 -0.0209406 1.29724 0.000468412 1.49478 0.0822929C1.69232 0.164117 1.86116 0.302682 1.97995 0.480465C2.09874 0.658248 2.16215 0.867264 2.16215 1.08108C2.16215 1.3678 2.04825 1.64278 1.84551 1.84552C1.64277 2.04826 1.36779 2.16216 1.08107 2.16216C0.867258 2.16216 0.658243 2.09876 0.480461 1.97997ZM0.780768 0.631639C0.691877 0.691034 0.622595 0.775455 0.581683 0.874226C0.540771 0.972997 0.530067 1.08168 0.550924 1.18654C0.57178 1.29139 0.623261 1.38771 0.698856 1.4633C0.774452 1.5389 0.870766 1.59038 0.97562 1.61124C1.08047 1.63209 1.18916 1.62139 1.28793 1.58048C1.3867 1.53956 1.47112 1.47028 1.53051 1.38139C1.58991 1.2925 1.62161 1.18799 1.62161 1.08108C1.62161 0.937721 1.56466 0.800233 1.46329 0.698862C1.36192 0.597491 1.22443 0.540541 1.08107 0.540541C0.974166 0.540541 0.869659 0.572243 0.780768 0.631639Z",
  transform: "translate(12.432617 1.3515625)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.480461 1.97997C0.30268 1.86118 0.164116 1.69234 0.0822923 1.49479C0.000468409 1.29725 -0.0209404 1.07988 0.020773 0.870173C0.0624865 0.660464 0.165449 0.467834 0.31664 0.316642C0.467831 0.16545 0.660459 0.0624869 0.870167 0.0207732C1.07987 -0.0209406 1.29724 0.000468412 1.49478 0.0822929C1.69232 0.164117 1.86116 0.302682 1.97995 0.480465C2.09874 0.658248 2.16215 0.867264 2.16215 1.08108C2.16215 1.3678 2.04825 1.64278 1.84551 1.84552C1.64277 2.04826 1.36779 2.16216 1.08107 2.16216C0.867258 2.16216 0.658243 2.09876 0.480461 1.97997ZM0.780768 0.631639C0.691877 0.691034 0.622595 0.775455 0.581683 0.874226C0.540771 0.972997 0.530067 1.08168 0.550924 1.18654C0.57178 1.29139 0.623261 1.38771 0.698856 1.4633C0.774452 1.5389 0.870766 1.59038 0.97562 1.61124C1.08047 1.63209 1.18916 1.62139 1.28793 1.58048C1.3867 1.53956 1.47112 1.47028 1.53051 1.38139C1.58991 1.2925 1.62161 1.18799 1.62161 1.08108C1.62161 0.937721 1.56466 0.800233 1.46329 0.698862C1.36192 0.597491 1.22443 0.540541 1.08107 0.540541C0.974166 0.540541 0.869659 0.572243 0.780768 0.631639Z",
  transform: "translate(9.459961 1.3515625)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.27027 5.67569C0.19859 5.67569 0.129846 5.64722 0.0791604 5.59653C0.0284749 5.54585 0 5.4771 0 5.40542L0 0.270271C0 0.198591 0.0284749 0.129846 0.0791604 0.0791603C0.129846 0.0284747 0.19859 0 0.27027 0L5.94595 0C6.01763 0 6.08637 0.0284747 6.13706 0.0791603C6.18774 0.129846 6.21622 0.198591 6.21622 0.270271L6.21622 5.40542C6.21622 5.4771 6.18774 5.54585 6.13706 5.59653C6.08637 5.64722 6.01763 5.67569 5.94595 5.67569L0.27027 5.67569ZM5.67568 5.13515L5.67568 0.540542L0.540541 0.540542L0.540541 5.13515L5.67568 5.13515Z",
  transform: "translate(1.8916016 6.216797)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.56757 0L7.56757 0.540541L0 0.540541L0 0L7.56757 0Z",
  transform: "translate(9.459961 6.4873047)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.56757 0L7.56757 0.540541L0 0.540541L0 0L7.56757 0Z",
  transform: "translate(9.459961 8.918945)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.56757 0L7.56757 0.540541L0 0.540541L0 0L7.56757 0Z",
  transform: "translate(9.459961 11.3515625)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1351 0L15.1351 0.540541L0 0.540541L0 0L15.1351 0Z",
  transform: "translate(1.8916016 13.783203)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1351 0L15.1351 0.540541L0 0.540541L0 0L15.1351 0Z",
  transform: "translate(1.8916016 16.216797)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgBlog = function SvgBlog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blog.9b53f6bd.svg";
export { ForwardRef as ReactComponent };